var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1719 5.78857L19.8867 8.07373L15.1992 3.38623L17.4844 1.10107C17.7188 0.866699 18.0117 0.749512 18.3633 0.749512C18.7148 0.749512 19.0078 0.866699 19.2422 1.10107L22.1719 4.03076C22.4062 4.26514 22.5234 4.55811 22.5234 4.90967C22.5234 5.26123 22.4062 5.5542 22.1719 5.78857ZM0.0234375 18.562L13.8516 4.73389L18.5391 9.42139L4.71094 23.2495H0.0234375V18.562Z",
    fill: "#001574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditInfo);
export default __webpack_public_path__ + "static/media/edit_info.f514426a641ac3200dc73f573dd70763.svg";
export { ForwardRef as ReactComponent };